<template>
<div id="pre-survey">
    <h3><em>Thanks{{ first }}!</em> You&rsquo;re now ready to take the TRAC360&deg; Assessment.</h3>
					<p>The assessment is made up of 12 questions and will take approximately 10-15 minutes to complete. As with any assessment of this type, your best response is often your first response&mdash;so trust your instincts.</p>
					<p><em>Note: Should you exit the assessment before answering all 12 questions, you will be required to start the assessment over again the next time you log in.</em></p> 
					<p>When you&rsquo;re ready, click/tap the button below to get started.</p>
					<p class="is-text-center"><a href="#" @click.prevent="$router.push('survey')" class="button">Take the Assessment</a></p>
</div>
</template>

<script>
/* eslint-disable */
import Axios from 'axios';

export default {
    name: 'Start',
    components: {
    },
    async created() {
        const res = await Axios.get('/user');
        this.user = res.data && res.data.user;
    },
    data: () => {
        return {
            user: ''
        }
    },
    computed: {
        first() {
            return this.user ? ' ' + this.user.first : ''
        }
    }
}
</script>
